
import { ResultData } from "@nt-portal/common-sdk";

import { TCMMasterGroupItem, TCMMasterGroupItemRule, TCMMasterGroupItemService } from "@nt-portal/tcm-sdk";
import { ValidateResult } from "@nt-portal/common-sdk";
import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";
import { createTCMMasterGroupItem } from "./master-group-items.service";


export interface TCMMasterGroupItemRuleOptions extends ControllerOptions<TCMMasterGroupItemRule> {

}

export const createTCMMasterGroupItemRule = (inObj: Partial<TCMMasterGroupItemRule>) => {
    let item: TCMMasterGroupItemRule = {
        expression: { condition: "and", expressions: [] },
        description: "",
        groupItem: createTCMMasterGroupItem({}),
        createdBy: ""
    }
    return item;
}


export class ClientTCMMasterGroupItemRuleService extends BaseClientService {

    private _service: TCMMasterGroupItemService;


    constructor() {
        super();
        this._service = new TCMMasterGroupItemService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }

    public set params(params: any) {
        this._service.params = params;
    }

    public get params() {
        return this._service.params ?? {};
    }


    public init(inObj: Partial<TCMMasterGroupItem>): TCMMasterGroupItem {
        return createTCMMasterGroupItem(inObj);
    }




    /**
      * Note: The ID in the options is for the Contract Item, not the rule.
      */
    public async getRule(options: TCMMasterGroupItemRuleOptions): Promise<TCMMasterGroupItemRule | null> {
        if (options.id && this.params.groupId) {
            let item = await this._service.getRule(options.id, this.token);
            return item;
        }
        return null;
    }

    /**
  * Note: The ID in the options is for the Contract Item, not the rule.
  */
    public async updateRule(options: TCMMasterGroupItemRuleOptions): Promise<TCMMasterGroupItemRule | null> {
        if (options.item && options.id && this.params.groupId)
            return await this._service.updateRule(options.id, this.token, options.item)
        return null;
    }

    /**
     * Note: The ID in the options is for the Contract Item, not the rule.
     */
    public async addRule(options: TCMMasterGroupItemRuleOptions): Promise<TCMMasterGroupItemRule | null> {
        if (options.item && options.id && this.params.groupId)
            return await this._service.saveRule(options.id, this.token, options.item)
        return null;
    }


    public async deleteRule(options: TCMMasterGroupItemRuleOptions) {
        if (options.id && this.params.groupId)
            return await this._service.deleteRule(options.id, this.token)
        return null;
    }





}